import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilsService } from '../../../sharedServices/utils.service';
import { ValidatorService } from '../../validator/validator.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-mu-form-input',
  templateUrl: './mu-form-input.component.html',
  styleUrls: ['./mu-form-input.component.sass'],
})
export class MuFormInputComponent {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() type: string;
  @Input() editableMask: boolean;
  @Input() iconCheck: boolean;
  @Input() changeInputType: boolean;
  @Input() maxLength: string;
  @Input() allowOnlyNumbers: boolean;
  @Input() placeholder?: string;

  constructor(
    private utilsService: UtilsService,
    public changeDetectorRef: ChangeDetectorRef,
    public validatorService: ValidatorService,
    private translateService: TranslateService
  ) {
    /** */
  }

  /**
   * get placeholder to control
   * @returns {boolean} response
   */
  get getPlaceholder(): string {
    return this.placeholder ? this.placeholder : this.translateService.instant('form.placeholder.' + this.controlName);
  }

  /**
   * method to clean numeric
   */
  async cleanNumeric(): Promise<void> {
    await this.utilsService.muSleep(1);
    const value = this.formData?.get(this.controlName).value;
    this.formData?.get(this.controlName).setValue(this.utilsService.cleanNumeric(value), { emitEvent: false });
  }

  /**
   *   method to change input type between text and password for eye icon
   *   @param {Event} event An Event with html element data
   *   @param {string} id html id
   */
  changeInputTypeAction(event: Event, id: string): void | boolean {
    this.utilsService.changeInputTypePassword(event, id);
  }
}
